import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { DevicesService } from '../../../../app/core/routing/services/devices/devices.service';
import { DevicesConstants, Enumvalues } from '../../../../app/core/routing/services/devices/constants/devices.constants';
import { throwError } from 'rxjs';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { srtDevice } from '../interface/devices-interface.i';
import { Subject } from 'rxjs/internal/Subject';
import { CommonService } from '../../../common/services/common.service';
import { NgbModalRef, NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ProfileService } from '../../../../app/core/routing/services/profile_api/profile.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Profile } from '../../../modules/profile/interface/profile.i';
import { Utils } from '../../../common/utils/utils';
import { first } from 'rxjs/internal/operators/first';
import { LANGUAGE_MAPPINGS } from '../../../common/constants/language-mappings.const';

@Component({
  selector: 'iposcen-srt-kiosk-dashboard',
  templateUrl: './srt-kiosk-dashboard.component.html',
  styleUrls: ['./srt-kiosk-dashboard.component.scss']
})
export class SrtKioskDashboardComponent implements OnInit {
  @ViewChild('searchSrtValue') animateThis: ElementRef;
  @ViewChild('pushUpdateModal') updatePopup: ElementRef;
  filterSrtString: string;
  srtFilterQueue = {};
  srtSearchQueue = {};
  srtSortQueue = {};
  blockServiceCall = false;
  allSrtDevicesData = [];
  displaySrtDevices = [];
  isMasterSel = false;
  pageVal: number;
  srtPaginationCount: number;
  totalSrtPages: number;
  srtTableSize: number;
  maxSize = 5;
  showFrom: number;
  isButtonsDisabled = true;
  srtUpdateHoverText = DevicesConstants.UPDATE_ICON_HOVER;
  srtRemoveIconText = DevicesConstants.REMOVE_ICON_HOVER;
  showTo: number;
  deviceConst = DevicesConstants;
  globalSrtSortValue: string;
  globalSrtSortBy: string;
  isAllSrtDevicesSelected: boolean;
  updateStoreID = DevicesConstants.STORE_ID;
  updateDeviceID = DevicesConstants.PC_FINDER_DEVICE_UUID;
  isSrtDataEmpty: boolean = false;
  isSelectAllCheckBoxClicked = false;
  allsrtDeviceIdData = [];
  allSrtConnectivityStatus = [];
  allStoreNameData = [];
  allSrtDeviceNameData = [];
  allSrtVersionData = [];
  closeSrtFilter = false;
  closeSrtSearch = false;
  searchSrtTag: string;
  isAllItemsSelectedData = new Map();
  isAllSelectedSrtData = new Map();
  srtSearchData: string;
  globalConst = GlobalConstants;
  srtConnectivityStatusFilterName = DevicesConstants.CONNECTIVITY_STATUS_VALUE_FILTER;
  srtConnectivityStatusHoverText = DevicesConstants.CONNECTIVITY_STATUS_HOVER;
  srtDeviceIdFilterName = DevicesConstants.SRT_DEVICE_ID_FILTER;
  srtStoreNameFilterName = DevicesConstants.SRT_STORE_NAME_FILTER;
  srtVersionFilterName = DevicesConstants.SRT_VERSION_FILTER;
  srtConnectivityStatusDropdownsrtSelectedValue: string;
  srtDeviceIdDropdownSelectedValue: string;
  srtStoreNameDropdownSelectedValue: string;
  srtVersionDropdownSelectedValue: string;
  loadSrtFlag: string;
  searchSrtData: string;
  openDeleteSrtModalPopup: boolean;
  isSrtDeviceRemoved: boolean;
  removeSrtDeviceMessage: string;
  deviceName: string;
  isSingleSrtDeviceSelected: boolean;
  singleSrtDelete: string;
  cancelSrtButton = GlobalConstants.CANCEL;
  searchSrtLabel = DevicesConstants.SEARCH_TEXT;
  showHideMoreFilters = true;
  srtDeviceName = DevicesConstants.DEVICE_NAME_SORT;
  srtConnectivityStatus = DevicesConstants.CONNECTIVITY_STATUS_VALUE_FILTER;
  srtStoreName = DevicesConstants.STORE_NAME_SORT;
  srtStoreNumber = DevicesConstants.STORE_NUMBER_SORT;
  srtVersion = DevicesConstants.SRT_VERSION;
  srtLastUpdate = DevicesConstants.LAST_UPDATE_SORT;
  srtLastConnectedTime = DevicesConstants.LAST_CONNECTED_SORT;
  valueForSearchInSrtDevice: string;
  deviceIdVal = DevicesConstants.SRT_DEVICE_ID_TEXT;
  srtSyncStatus = DevicesConstants.SRT_SYNC_STATUS;
  srtDeviceNameVal = DevicesConstants.DEVICENAME;
  srtStoreNameVal = DevicesConstants.STORENAME;
  selectedSrtDevicesList = [];
  selectedSrtDevicesNameList: string;
  sendSrtSelectedItem: any;
  private modalOption: NgbModalOptions = {};
  srtDevicesText = GlobalConstants.DEVICES_TEXT;
  direction: string;
  updateSrtDeviceInfo: srtDevice;
  selectedProfileId: string;
  lastSrtUpdate: any;
  profileDownloadedData: Profile[] = [];
  showRetailGif = false;
  isDownloadedProfileEmpty = false;
  selectedDeviceIds = [];
  isProfileIdSelected = false;
  openSucessMsg = false;
  isUpdatesPushed = false;
  allSrtCsvData = [];
  displayDownloadedProfileData = [];
  private modalRef: NgbModalRef;
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  retailerID = sessionStorage.getItem(GlobalConstants.RETAILERID);
  private ngUnsubscribe = new Subject();

  constructor(private devicesService: DevicesService, private modalService: NgbModal,
    private cmnService: CommonService, private profileService: ProfileService) { }

  ngOnInit(): void {
    this.pageVal = 1;
    this.srtTableSize = 10;
    this.showFrom = ((this.pageVal - 1) * this.srtTableSize) + 1;
    this.showTo = Math.min(this.pageVal * this.srtTableSize);
    this.globalSrtSortBy = DevicesConstants.LAST_UPDATE_SORT;
    this.globalSrtSortValue = DevicesConstants.DESCENDING_ORDER;
    this.valueForSearchInSrtDevice = DevicesConstants.SRT_DEVICE_ID_TEXT;
    this.loadSrtFlag = DevicesConstants.LOAD_FLAG;
    this.direction = this.cmnService.direction;
    this.getSearchSortFilterData();
    this.cmnService.getRetailGifValue
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(data => {
        this.showRetailGif = data;
      });
  }

  getSearchSortFilterData() {
    this.filterSrtString = '';
    this.blockServiceCall = false;
    this.pageVal = 1;
    if (this.srtFilterQueue || this.srtSearchQueue || this.srtSortQueue) {
      for (const [filterKeyName, fliterData] of Object.entries(this.srtFilterQueue)) {
        this.filterSrtString += `&${filterKeyName}=${fliterData}`;
      }
      if (this.srtSearchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.srtSearchQueue)) {
          this.filterSrtString += `&${filterKeyName}=${fliterData}`;
        }
      }
      if (this.srtSortQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.srtSortQueue)) {
          this.filterSrtString += `&${filterKeyName}=${fliterData}`;
        }
      }
      // block SRT API calls if SearchData includes string % 
      if (this.srtSearchQueue) {
        for (const [filterKeyName, fliterData] of Object.entries(this.srtSearchQueue)) {
          if (String(fliterData).includes("%")) {
            this.blockServiceCall = true;
            break;
          }
        }
      }
      if (!this.blockServiceCall) {
        this.getSrtDeviceData(this.filterSrtString);
      }
    }
  }
  getSrtDeviceData(filterSrtString?: string) {
    this.devicesService.getAllDevicesByUserID(this.globalSrtSortBy, this.globalSrtSortValue, this.pageVal, filterSrtString, this.retailerID)
      .subscribe(getAllSrtResponse => {
        if (getAllSrtResponse['device']) {
          if (!this.isSelectAllCheckBoxClicked && getAllSrtResponse['paginationContext'] !== undefined)
            this.mapSrtResponseData(getAllSrtResponse)
        }
      },
        error => {
          this.isSrtDataEmpty = true;
          this.handleError(error, this.constructor.name);
        });
  }
  mapSrtResponseData(response: any) {
    this.allSrtDevicesData = response['device'] as srtDevice[];
    this.srtPaginationCount = response['paginationContext'].totalItems;
    this.totalSrtPages = response['paginationContext'].totalPages;
    this.showFrom = ((this.pageVal - 1) * this.srtTableSize) + 1;
    this.showTo = Math.min(this.pageVal * this.srtTableSize, this.srtPaginationCount);
    this.displaySrtDevices = [];
    this.isSrtDataEmpty = (this.allSrtDevicesData.length === 0) || false;
    this.allSrtDevicesData.forEach(ele => {
      ele.isSelected = this.isMasterSel;
      this.displaySrtDevices.push(ele);
    });

    if (this.displaySrtDevices.length === 0) {
      this.showFrom = 0;
      this.showTo = 0;
    } else {
      this.displaySrtDevices = [];
      this.allSrtDevicesData.forEach(ele => {
        ele.isSelected = this.isMasterSel;
        this.displaySrtDevices.push(ele);
      });
      this.allsrtDeviceIdData = response['deviceIDList'].sort();
      this.allSrtConnectivityStatus = this.statusList();
      this.allStoreNameData = response['storeNameList'].sort();
      this.allSrtVersionData = response['srtVersionList'].sort();
    }
  }

  onSrtTableDataChange(event) {
    this.isSelectAllCheckBoxClicked = false;
    this.pageVal = event;
    if (this.isAllSrtDevicesSelected) {
      this.isMasterSel = true;
    }
    this.getSrtDeviceData(this.filterSrtString);
  }

  // Handling error within the component
  handleError(error, componentName) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // client-side error
      errorMessage = `Error: ${error.error.message}\nComponent: ${componentName}`;
    } else {
      // server-side error
      errorMessage = `Error Code: ${error.responseContext.exceptionResponse.errorCode}\nMessage: ${error.responseContext.exceptionResponse.errorMessage} with Status Code: ${error.responseContext.exceptionResponse.statusCode}\nComponent: ${componentName}`;
    }

    return throwError(errorMessage);
  }


  srtSpell(option: string) {
    if (option === DevicesConstants.INACTIVE) {
      return GlobalConstants.INACTIVE_TEXT;
    } else if (option === DevicesConstants.RECENTLY_CONNECTED) {
      return GlobalConstants.RECENTLY_CONNECTED_TEXT;
    } else if (option === DevicesConstants.DISCONNECTED) {
      return GlobalConstants.DISCONNECTED_TEXT;
    } else if (option === DevicesConstants.CONNECTED) {
      return GlobalConstants.CONNECTED_TEXT;
    } else if (option === DevicesConstants.TWO_WEEKS) {
      return DevicesConstants.TWO_WEEKS;
    }
  }

  onSrtFilter(selectedSrtFilterNames: string, srtSelectedValue: string) {
    this.closeSrtFilter = true;
    this.isAllItemsSelectedData.clear();
    this.isAllSrtDevicesSelected = false;
    switch (selectedSrtFilterNames) {
      case DevicesConstants.CONNECTIVITY_STATUS_VALUE_FILTER:
        this.srtConnectivityStatusDropdownsrtSelectedValue = this.srtSpell(srtSelectedValue);;
        break;
      case DevicesConstants.SRT_DEVICE_ID_FILTER:
        this.srtDeviceIdDropdownSelectedValue = srtSelectedValue;
        break;
      case DevicesConstants.SRT_STORE_NAME_FILTER:
        this.srtStoreNameDropdownSelectedValue = srtSelectedValue;
        break;
      case DevicesConstants.SRT_VERSION_FILTER:
        this.srtVersionDropdownSelectedValue = srtSelectedValue;
        break;
      default:
        return;
    }
    // To revert the new values added for Processor and Device_type end
    // Added encodeURIComponent to status filter do avoid issues when special chars included
    this.srtFilterQueue[selectedSrtFilterNames] = encodeURIComponent(srtSelectedValue);
    this.getSearchSortFilterData();
    this.closeSrtSearch = false;
    this.srtSearchData = DevicesConstants.EMPTY_VALUE;
    this.pageVal = 1;
    this.isButtonsDisabled = true;
    this.isMasterSel = false;
  }

  //To return status in required order
  statusList() {
    return [DevicesConstants.CONNECTED, DevicesConstants.DISCONNECTED, DevicesConstants.TWO_WEEKS];
  }

  clearSrtFilter(srtFilterName?: string) {
    this.pageVal = 1;
    this.isButtonsDisabled = true;
    this.isMasterSel = false;
    this.isAllItemsSelectedData.clear();
    this.isSelectAllCheckBoxClicked = false;
    // this.pushEmptySkuId = false;
    if (srtFilterName && srtFilterName === DevicesConstants.CONNECTIVITY_STATUS_VALUE_FILTER) {
      delete this.srtFilterQueue[srtFilterName];
      this.allSrtConnectivityStatus = [];
      if (JSON.stringify(this.srtFilterQueue) === JSON.stringify({})) {
        this.filterSrtString = '';
        this.closeSrtFilter = false;
      }
      this.srtConnectivityStatusDropdownsrtSelectedValue = '';
      this.getSearchSortFilterData();
    } else if (srtFilterName && srtFilterName === DevicesConstants.SRT_STORE_NAME_FILTER) {
      delete this.srtFilterQueue[srtFilterName];
      this.allStoreNameData = [];
      if (JSON.stringify(this.srtFilterQueue) === JSON.stringify({})) {
        this.filterSrtString = '';
        this.closeSrtFilter = false;
      }
      this.srtStoreNameDropdownSelectedValue = '';
      this.getSearchSortFilterData();
    } else if (srtFilterName && srtFilterName === DevicesConstants.SRT_VERSION_FILTER) {
      delete this.srtFilterQueue[srtFilterName];
      this.allSrtVersionData = [];
      if (JSON.stringify(this.srtFilterQueue) === JSON.stringify({})) {
        this.filterSrtString = '';
        this.closeSrtFilter = false;
      }
      this.srtVersionDropdownSelectedValue = '';
      this.getSearchSortFilterData();
    } else {
      this.filterSrtString = '';
      this.srtFilterQueue = {};
      this.getSearchSortFilterData();
      this.closeSrtFilter = false;
      this.closeSrtSearch = false;
      this.searchSrtData = DevicesConstants.EMPTY_VALUE;
      this.allSrtConnectivityStatus = [];
      this.allStoreNameData = [];
      this.allSrtVersionData = [];
      this.srtConnectivityStatusDropdownsrtSelectedValue = '';
      this.srtStoreNameDropdownSelectedValue = '';
      this.srtVersionDropdownSelectedValue = '';
    }
  }

  showHideMoreFiltersClick() {
    this.showHideMoreFilters = !this.showHideMoreFilters;
  }

  sortSrtValues(sortKey: string) {
    this.isAllItemsSelectedData.clear();
    this.isSelectAllCheckBoxClicked = false;
    this.isMasterSel = false;
    switch (sortKey) {
      case (DevicesConstants.DEVICE_NAME_SORT):
        this.sortSrtTableWithAscandDesc(DevicesConstants.DEVICE_NAME_SORT);
        break;
      case (DevicesConstants.CONNECTIVITY_STATUS_VALUE_FILTER):
        this.sortSrtTableWithAscandDesc(DevicesConstants.CONNECTIVITY_STATUS_VALUE_FILTER);
        break;
      case (DevicesConstants.STORE_NAME_SORT):
        this.sortSrtTableWithAscandDesc(DevicesConstants.STORE_NAME_SORT);
        break;
      case (DevicesConstants.STORE_NUMBER_SORT):
        this.sortSrtTableWithAscandDesc(DevicesConstants.STORE_NUMBER_SORT);
        break;
      case (DevicesConstants.SRT_VERSION):
        this.sortSrtTableWithAscandDesc(DevicesConstants.SRT_VERSION);
        break;
      case (DevicesConstants.LAST_UPDATE_SORT):
        this.sortSrtTableWithAscandDesc(DevicesConstants.LAST_UPDATE_SORT);
        break;
      case (DevicesConstants.SRT_SYNC_STATUS):
        this.sortSrtTableWithAscandDesc(DevicesConstants.SRT_SYNC_STATUS);
        break;
      case (DevicesConstants.LAST_CONNECTED_SORT):
        this.sortSrtTableWithAscandDesc(DevicesConstants.LAST_CONNECTED_SORT);
        break;
      default: {
      }
    }
  }

  sortSrtTableWithAscandDesc(tempval: string) {
    this.globalSrtSortValue = this.globalSrtSortValue !== DevicesConstants.ASCENDING_ORDER ? DevicesConstants.ASCENDING_ORDER :
      DevicesConstants.DESCENDING_ORDER;
    this.globalSrtSortBy = tempval;
    this.getSearchSortFilterData();
  }

  onSrtSelectChange(value) {
    this.blockServiceCall = false;
    if (value === Enumvalues.VALUE_1) {
      this.searchSrtTag = DevicesConstants.SRT_DEVICE_ID_SEARCH;
      this.valueForSearchInSrtDevice = DevicesConstants.SRT_DEVICE_ID_TEXT;
    } else if (value === Enumvalues.VALUE_2) {
      this.searchSrtTag = DevicesConstants.DEVICE_NAME_SEARCH;
      this.valueForSearchInSrtDevice = DevicesConstants.DEVICENAME;
    } else if (value === Enumvalues.VALUE_3) {
      this.searchSrtTag = DevicesConstants.STORE_NAME_SEARCH;
      this.valueForSearchInSrtDevice = DevicesConstants.STORENAME;
    }
  }

  searchSrtDevice(srtSearchData) {
    this.isAllItemsSelectedData.clear();
    this.isSelectAllCheckBoxClicked = false;
    this.closeSrtSearch = true;
    if (this.loadSrtFlag === DevicesConstants.LOAD_FLAG && !this.searchSrtTag) {
      this.searchSrtTag = DevicesConstants.SRT_DEVICE_ID_SEARCH;
      this.loadSrtFlag = DevicesConstants.UNLOAD_FLAG;
    }
    if (srtSearchData && this.searchSrtTag) {
      this.srtSearchQueue = {}; // To clear previous selection.
      this.srtSearchQueue[this.searchSrtTag] = srtSearchData;
      this.getSearchSortFilterData();
    } else {
      this.getSrtDeviceData();
      this.pageVal = 1;
    }
    this.isMasterSel = false;
    this.isButtonsDisabled = true;
  }

  searchSrtDevicessonEnter(srtSearchData) {
    this.animateThis.nativeElement.blur();
    this.searchSrtDevice(srtSearchData);
  }

  clearSrtSearch(value: string) {
    if (value?.length === 0 && this.closeSrtSearch) {
      this.closeSrtSearch = false;
      this.animateThis.nativeElement.value = '';
      this.srtSearchQueue = {};
      this.getSearchSortFilterData();
      this.searchSrtData = DevicesConstants.EMPTY_VALUE;
      this.showFrom = this.pageVal = 1;
      this.showTo = 10;
      this.isButtonsDisabled = true;
      this.isMasterSel = false;
      this.isAllItemsSelectedData.clear();
    }
  }
  getSelectedSrtDevicesList() {
    this.selectedSrtDevicesList = Array.from(this.isAllItemsSelectedData.values());
    this.isMasterSel = this.selectedSrtDevicesList.length === this.srtPaginationCount;
    this.isButtonsDisabled = this.selectedSrtDevicesList.length > 1 ? false : true;
    this.selectedSrtDevicesNameList = this.selectedSrtDevicesList.map(e => e.deviceName)
      .join(', ');
    this.selectedDeviceIds = this.selectedSrtDevicesList.map(e => e.deviceID);
    this.sendSrtSelectedItem = this.selectedSrtDevicesList.length > 1;
  }

  //IGC-6 Delete SRT Individual/multiple devices
  removeSrtItem(item) {
    this.openDeleteSrtModalPopup = !this.openDeleteSrtModalPopup;
    this.isSrtDeviceRemoved = true;
    this.isSingleSrtDeviceSelected = true;
    this.removeSrtDeviceMessage = DevicesConstants.REMOVE_ONE_SRT_DEVICE;
    this.deviceName = item.deviceName;
    this.singleSrtDelete = item.deviceID;
  }

  closeRemoveSrtDeviceModal() {
    this.getSrtDeviceData();
    this.openDeleteSrtModalPopup = false;
    this.clearSrtFilter();
  }

  cancelSrtPopupButton() {
    this.openDeleteSrtModalPopup = false;
  }

  removeAllSelectedSrtDevice() {
    if (this.selectedSrtDevicesList.length > 0) {
      this.openDeleteSrtModalPopup = !this.openDeleteSrtModalPopup;
      this.isSrtDeviceRemoved = true;
      if (this.selectedSrtDevicesList.length === 1) {
        this.isSingleSrtDeviceSelected = true;
        this.removeSrtDeviceMessage = DevicesConstants.REMOVE_ONE_SRT_DEVICE;
        this.deviceName = this.selectedSrtDevicesList[0].deviceName;
      } else {
        this.isSingleSrtDeviceSelected = false;
        this.removeSrtDeviceMessage = DevicesConstants.REMOVE_MULTIPLE_SRT_DEVICE;
      }
    }
  }

  removeSrtDeviceList() {
    if (this.singleSrtDelete === '') {
      const removingList = this.selectedSrtDevicesList.map(item => item.deviceID);
      //IIT2-4967
      this.removeSrtDevices({ 'deviceIDs': removingList });
    } else {
      this.removeSrtDevices({ 'deviceIDs': [this.singleSrtDelete] });
    }
  }

  removeSrtDevices(removeData) {
    this.devicesService.deleteSrtDevices(removeData, this.retailerID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(deleteDomainResponse => {
        if (deleteDomainResponse.responseContext.statusCode === 200) {
          this.searchSrtData = '';
          this.isMasterSel = false;
          this.isSrtDeviceRemoved = false;
          this.singleSrtDelete = '';
          this.isButtonsDisabled = true;
          this.isAllSelectedSrtData.clear();
        }
      },
        error => {
          this.handleError(error, this.constructor.name);
        });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  checkAndUncheckSrt(event) {
    if (this.filterSrtString) {
      this.isAllItemsSelectedData.clear();
      if (event) {
        this.isSelectAllCheckBoxClicked = true;
        this.devicesService.selectAllDevices(this.filterSrtString, this.retailerID)
          .subscribe(res => {
            {
              res.device.forEach(value => {
                this.isAllItemsSelectedData.set(value.deviceID, value);
              });
              this.getSelectedSrtDevicesList();
            }
          });
      } else {
        this.isSelectAllCheckBoxClicked = false;
        this.isAllItemsSelectedData.clear();
        this.getSelectedSrtDevicesList();
      }
    } else {
      if (event) {
        this.isSelectAllCheckBoxClicked = true;
        this.devicesService.selectAllDevices('', this.retailerID)
          .subscribe(res => {
            res.device.forEach(value => {
              this.isAllItemsSelectedData.set(value.deviceID, value);
            });
            this.getSelectedSrtDevicesList();
          });
      } else {
        this.isSelectAllCheckBoxClicked = false;
        this.isAllItemsSelectedData.clear();
        this.getSelectedSrtDevicesList();
      }
    }
    this.isAllSrtDevicesSelected = this.isMasterSel;
    this.displaySrtDevices.forEach(ele => {
      ele.isSelected = this.isMasterSel;
    });
  }

  isAllSrtSelected(data) {
    this.isSelectAllCheckBoxClicked = false;
    if (this.isAllItemsSelectedData.has(data.deviceID)) {
      this.isAllItemsSelectedData.delete(data.deviceID);
    } else {
      this.isAllItemsSelectedData.set(data.deviceID, data);
    }
    const isAllChecked = this.displaySrtDevices.every(item => item.isSelected === true);
    this.isMasterSel = isAllChecked ? true : false;
    this.getSelectedSrtDevicesList();
  }

  dismissUpdate() {
    this.modalRef.dismiss();
    this.selectedProfileId = '';
    this.isProfileIdSelected = false;
  }

  openUpdatePopUP(updateModal) {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    this.modalRef = this.modalService.open(updateModal, { windowClass: 'update-device-class' });
    this.modalRef.result.then();
    this.selectedProfileId = '';
    this.isProfileIdSelected = false;
  }

  updateSrtDevice(updateModal, srtDevice: srtDevice) {
    this.updateSrtDeviceInfo = srtDevice;
    this.lastSrtUpdate = this.updateSrtDeviceInfo.deviceUpdatedTime;
    this.isSingleSrtDeviceSelected = true;
    this.pageVal = 1;
    this.getAllCompletedProfiles();
    this.openUpdatePopUP(updateModal);
  }

  updateMultiSrtDevices(updateMultiModal) {
    this.pageVal = 1;
    this.openUpdatePopUP(updateMultiModal);
    this.getAllCompletedProfiles();
  }

  getAllCompletedProfiles() {
    this.profileService.getAllProfilesByUser(this.retailerID)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getAllProfileResponse => {
        this.mapResponseData(getAllProfileResponse['profile']);
      },
        err => {
          Utils.handleError(err, this.constructor.name)
        });
  }

  mapResponseData(response) {
    this.profileDownloadedData = (response as Profile[]);
    this.displayDownloadedProfileData = [];
    this.profileDownloadedData.forEach(ele => {
      if (ele.packageStatus === GlobalConstants.COMPLETED_STATUS) {
        this.displayDownloadedProfileData.push(ele);
      }
    });
    this.displayDownloadedProfileData.sort((profile1, profile2) => {
      return +new Date(profile2.updatedDate) - +new Date(profile1.updatedDate);
    });
    this.showFrom = ((this.pageVal - 1) * this.srtTableSize) + 1;
    this.showTo = (this.displayDownloadedProfileData.length > 10) ? Math.min(this.pageVal * this.srtTableSize) : this.displayDownloadedProfileData.length;
    this.isDownloadedProfileEmpty = (this.displayDownloadedProfileData.length === 0) || false;
    this.cmnService.setRetailGifValue(false);
  }

  onProfilePaginationClick(event) {
    this.pageVal = event;
    this.showFrom = ((this.pageVal - 1) * this.srtTableSize) + 1;
    this.showTo = Math.min(this.pageVal * this.srtTableSize, this.displayDownloadedProfileData.length);
  }

  selectProfileId(data, event) {
    if (data) {
      this.selectedProfileId = data.profileId;
      this.isProfileIdSelected = true;
    } else {
      this.isProfileIdSelected = false;
    }
  }

  // For IGC-12
  downloadSrtDevices() {
    if (navigator.onLine) {
      const srtDeviceReqBody = {
        csvHeaders:
          this.createSrtHeaders()
      };
      if (this.filterSrtString) {
        this.devicesService.postdownloadcsvSrtDevicebyFilter(this.filterSrtString, srtDeviceReqBody, this.retailerID)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(getAllDevicesResponseByFilter => {
            var devicesResponseByFilter: any = getAllDevicesResponseByFilter;
            this.downloadSrtCsv(devicesResponseByFilter);
          });
      } else {
        this.devicesService.DownloadAllSrtDevices(srtDeviceReqBody, this.retailerID)
          .pipe(takeUntil(this.ngUnsubscribe))
          .subscribe(getAllDevicesResponse => {
            var SrtDevicesResponse: any = getAllDevicesResponse
            this.downloadSrtCsv(SrtDevicesResponse);
          });
      }
    }
  }

  downloadSrtCsv(SrtCsvResponse) {
    this.allSrtCsvData = SrtCsvResponse;
    let filename = DevicesConstants.SRT_DEVICE_CSV_FILENAME;
    let userfilename = Utils.getdownloadLink() + '_' + filename;
    Utils.downloadCsvFile(this.allSrtCsvData, userfilename);
  }

  createSrtHeaders() {
    const srtDeviceReqBody = {
      csvHeaders: []
    };
    srtDeviceReqBody.csvHeaders.push(DevicesConstants.SRT_DEVICE_ID_TEXT);
    srtDeviceReqBody.csvHeaders.push(DevicesConstants.DEVICENAME);
    srtDeviceReqBody.csvHeaders.push(GlobalConstants.CONNECTIVITY_STATUS);
    srtDeviceReqBody.csvHeaders.push(GlobalConstants.USERS_STORES_STORE_NAME);
    srtDeviceReqBody.csvHeaders.push(GlobalConstants.USERS_STORES_STORE_NUM);
    srtDeviceReqBody.csvHeaders.push(GlobalConstants.STORE_ID);
    srtDeviceReqBody.csvHeaders.push(DevicesConstants.SRT_VERSION_TEXT);
    srtDeviceReqBody.csvHeaders.push(DevicesConstants.DEVICE_UPDATED_TIME);
    srtDeviceReqBody.csvHeaders.push(DevicesConstants.SRT_SYNC_STATUS_TEXT);
    srtDeviceReqBody.csvHeaders.push(DevicesConstants.SRT_LAST_CONNECTED_TIME);
    return srtDeviceReqBody.csvHeaders;
  }

  pushSrtStatus(data) {
    this.isUpdatesPushed = data;
    let updateData = {
      pushProfiles: [
        {
          profileID: this.selectedProfileId
        }
      ],
      deviceIDs: this.selectedDeviceIds.length > 1 ? this.selectedDeviceIds : [this.updateSrtDeviceInfo.deviceID]
    }
    this.devicesService.updateSingleAndMultipleSrtDevices(updateData)
      .pipe(takeUntil(this.ngUnsubscribe)).pipe(first()).subscribe(() => {
      });
  }

  getSrtClosedStatus(event) {
    location.reload();
  }

  openModals(modal: any) { modal.open(this.selectedSrtDevicesList); }

  pushSrtUpdates() {
    this.openModals(this.updatePopup);
  }

  getLanguageNames(langCodeList) {
    if (langCodeList == undefined) return undefined;
    else {
      const languageArray = this.removeStringifiedArray(langCodeList);
      for (let i = 0; i < languageArray.length; i++) {
        if (languageArray[i] === GlobalConstants.CHINESE_TW) {
          languageArray[i] = GlobalConstants.CHINESE_HANT;
        } else if (languageArray[i] === GlobalConstants.CHINESE_CN) {
          languageArray[i] = GlobalConstants.CHINESE_HANS;
        }
      }
      const langNameList: any = [];
      LANGUAGE_MAPPINGS.forEach(data => {
        if (data.langCode === GlobalConstants.CHINESE_TW) {
          data.langCode = GlobalConstants.CHINESE_HANT;
        } else if (data.langCode === GlobalConstants.CHINESE_CN) {
          data.langCode = GlobalConstants.CHINESE_HANS;
        }
        const langCode = languageArray.find(item => item.toLowerCase() === data.langCode.toLowerCase());
        if (langCode) {
          langNameList.push(data.langInEng);
        }
      });
      const result = langNameList?.join(', ');
      return result;
    }
  }

  removeStringifiedArray(data) {
    const finalArr = [];
    if (data[0] === "") return finalArr;
    else {
      if (data[0].split(",").length == 1) {
        finalArr.push(JSON.parse(data[0]));
        return finalArr;
      } else {
        const stringifiedArr = data[0].split(",");
        for (let i = 0; i < stringifiedArr.length; i++) {
          finalArr.push(JSON.parse(stringifiedArr[i]));
        }
        return finalArr;
      }
    }
  }
}
